var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRssSimple = function SvgIconRssSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.5a1 1 0 0 1 1-1A15.26 15.26 0 0 1 20.5 18.75a1 1 0 0 1-2 0A13.26 13.26 0 0 0 5.25 5.5a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.25a1 1 0 0 1 1-1 8.5 8.5 0 0 1 8.5 8.5 1 1 0 1 1-2 0 6.5 6.5 0 0 0-6.5-6.5 1 1 0 0 1-1-1M6.75 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconRssSimple;